var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptEyecopy02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 20",
    style: {
      enableBackground: "new 0 0 30 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#98A2BB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.19,9.52c-0.13-0.18-2.48-3.33-5.88-5.04l-0.61,1.2c2.46,1.24,4.36,3.36,5.08,4.24 c-1.05,1.28-4.6,5.18-8.71,5.18c-0.38,0-0.74-0.04-1.11-0.1l-0.64,1.26c0.57,0.12,1.15,0.2,1.75,0.2c5.57,0,9.93-5.88,10.11-6.13 C25.37,10.08,25.38,9.75,25.19,9.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.19,12.6l-0.66,1.3c0.18,0.03,0.37,0.06,0.56,0.06c2.24,0,4.05-1.81,4.05-4.05c0-1.1-0.44-2.09-1.15-2.82 L17.32,8.4c0.29,0.43,0.46,0.95,0.46,1.51C17.78,11.37,16.63,12.55,15.19,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,10l1.27-2.5l0.61-1.2l0.58-1.14l0.62-1.22l1.22-2.4c0.09-0.17,0.02-0.38-0.15-0.47l-0.58-0.3 c-0.17-0.09-0.38-0.02-0.47,0.15l-1.34,2.64c-0.54-0.11-1.1-0.19-1.67-0.19c-5.57,0-9.93,5.88-10.11,6.13 c-0.17,0.24-0.17,0.56,0,0.8c0.13,0.18,2.45,3.29,5.82,5.01L9.5,17.85c-0.09,0.17-0.02,0.38,0.15,0.47l0.58,0.3 c0.17,0.09,0.38,0.02,0.47-0.15c0,0,0,0,0,0l1.32-2.59l0.62-1.22l0.58-1.15l0.61-1.2L15,10z M12.8,11.35 c-0.26-0.42-0.42-0.91-0.42-1.44c0-1.43,1.11-2.59,2.52-2.68L12.8,11.35z M11.4,14.12c-2.42-1.24-4.31-3.33-5.02-4.2 c1.05-1.28,4.6-5.18,8.71-5.18c0.35,0,0.7,0.04,1.04,0.09l-0.55,1.08c-0.16-0.02-0.32-0.05-0.49-0.05c-2.24,0-4.05,1.81-4.05,4.05 c0,1.07,0.42,2.04,1.1,2.76L11.4,14.12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptEyecopy02);
export default __webpack_public_path__ + "static/media/recrypt_eye copy-02.6e0c017a.svg";
export { ForwardRef as ReactComponent };